module.exports = __webpack_public_path__ + "img/4.0c9f7572.jpg";